module.exports = __webpack_public_path__ + "img/d-step1.a485e217.png";